module.exports = __webpack_public_path__ + "img/icon_help.ddaabd60.svg";